export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // outbound grey,
  MAIN_COLOR: '#191919', // outbound seaweed
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#1A4EDF', // outbound teal
  SECONDARY_COLOR: '#1A4EDF', // outbound teal
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
